import React, { useRef } from 'react'
import { useContext } from 'react'
import { useAuth0 } from '../services/auth'
import { DataContext } from '../contexts/DataProvider'
import { Alert, Button, CircularProgress, Snackbar, Container, Grid, Paper, Typography } from '@mui/material'
import SelectContract from './SelectContract'
import SingleUser from './SingleUser/SingleUser'
import ContractTests from './ContractTests/ContractTests'
import RangeSelect from './RangeSelect'
import ContractUsers from './ContractUsers/ContractUsers'
import ContractDevices from './ContractDevices/ContractDevices'
import { styled } from '@mui/material/styles'
import Logo from '../../assets/logo-mssherpa.svg'

const StyledWrapper = styled(Grid)(() => ({
  '&.no-box-shadow div': {
    boxShadow: 'none',
  },
}))

const StyledLogin = styled(Paper)(({ theme }) => ({
  padding: '1.5rem',
  marginTop: '3rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  maxWidth: '25rem',
  margin: '3rem auto 0',
  svg: {
    maxWidth: '10.625rem',
    marginBottom: '2rem',
    '.st0': {
      fill: theme.palette.primary.contrastText,
    },
  },
}))

const StyledTitle = styled(Typography)(() => ({
  width: '100%',
  textAlign: 'center',
}))

const StyledLoaderContainer = styled(Container)(() => ({
  height: '20rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

function DashboardContent() {
  const { authLoading, isAuthenticated, loginWithRedirect, user } = useAuth0()
  const { activeContract, error, setError } = useContext(DataContext)
  const pdfContainerRef = useRef(null)

  if (!authLoading && !isAuthenticated) {
    return (
      <StyledLogin>
        <Logo />
        <StyledTitle variant="h5" color="secondary" mb={4}>
          Welcome to MS Sherpa <br /> Internal Dashboard
        </StyledTitle>

        <Button
          variant="contained"
          onClick={async () => {
            await loginWithRedirect({
              appState: { targetUrl: window.location.pathname },
            })
          }}
        >
          Log In
        </Button>
      </StyledLogin>
    )
  }

  if (!isAuthenticated || authLoading) {
    return (
      <StyledLoaderContainer maxWidth="lg">
        <CircularProgress size={70} />
      </StyledLoaderContainer>
    )
  }

  return isAuthenticated ? (
    <Container maxWidth="lg">
      <StyledWrapper container spacing={3} ref={pdfContainerRef} className="test">
        <SelectContract />
        <RangeSelect pdfContainerRef={pdfContainerRef.current} />
        {activeContract && (
          <>
            <ContractUsers />
            <ContractTests />
            <ContractDevices />
            <SingleUser />
          </>
        )}
      </StyledWrapper>

      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={error.isError}
        autoHideDuration={4000}
        onClose={() =>
          setError({
            isError: false,
            errorMessage: '',
          })
        }
      >
        <Alert severity="error">{error.errorMessage}</Alert>
      </Snackbar>
    </Container>
  ) : (
    <Button
      variant="contained"
      onClick={async () => {
        await loginWithRedirect({
          appState: { targetUrl: window.location.pathname },
        })
      }}
    >
      Log In
    </Button>
  )
}

export default function Dashboard() {
  return <DashboardContent />
}
